module.exports = __webpack_public_path__ + "img/pointuse-s.7c2c286d.png";